import { Separator } from '@oasisprotocol/ui-library/src/components/ui/separator'

export const LayoutDivider = () => <Separator className="my-6" />
export const DashboardDivider = () => {
  return <Separator className="mb-6 md:mt-0 md:mb-6" />
}
export const CardDivider = () => <Separator className="my-10" />
